const romanian = {
    'STAFF_MANAGEMENT.Title_Point': "Punct de pontaj",
    'STAFF_MANAGEMENT.Title_Attendance': "Prezență",
    'STAFF_MANAGEMENT.UseLocation': "Folosește locația mea",
    'STAFF_MANAGEMENT.SetPoint': "Setează punctul de pontaj",
    'STAFF_MANAGEMENT.SetPointHelp': "Stai în locul unde lucrătorii își înregistrează intrarea, apoi salvează locația.",
    'STAFF_MANAGEMENT.CheckPin': "Verifică dacă acesta este locul corect",
    'STAFF_MANAGEMENT.CheckSpot': "Mută marcajul, apoi salvează",
    'STAFF_MANAGEMENT.Retake': "Reia",
    'STAFF_MANAGEMENT.Save': "Salvează",
    'STAFF_MANAGEMENT.Saving': "Se salvează…",
    'STAFF_MANAGEMENT.Locating': "Îți determinăm locația mai precis. Rămâi la punctul de pontaj — poate dura până la 15 secunde.",
    'STAFF_MANAGEMENT.LocationAccuracy': "Precizie estimată: { accuracy } m",
    'STAFF_MANAGEMENT.LowAccuracyTitle': "Precizie redusă a locației",
    'STAFF_MANAGEMENT.LowAccuracyHelp': "Verifică marcajul și mută-l dacă este nevoie.",
    'STAFF_MANAGEMENT.LocationPermission': "Permite accesul la locație în setările browserului, apoi încearcă din nou.",
    'STAFF_MANAGEMENT.LocationTimeout': "Locația nu a putut fi determinată la timp. Rămâi la punctul de pontaj și încearcă din nou.",
    'STAFF_MANAGEMENT.LocationUnavailable': "Locația nu este disponibilă. Verifică setările de localizare ale dispozitivului și încearcă din nou.",
    'STAFF_MANAGEMENT.MapUnavailable': "Harta nu a putut fi încărcată. Încearcă din nou.",
    'STAFF_MANAGEMENT.Ready': "Pregătit pentru pontaj",
    'STAFF_MANAGEMENT.UpdateLocation': "Actualizează locația",
    'STAFF_MANAGEMENT.ViewQr': "Vezi codul QR",
    'STAFF_MANAGEMENT.PointCreated': "Punct de pontaj setat",
    'STAFF_MANAGEMENT.PointUpdated': "Punct de pontaj actualizat",
    'STAFF_MANAGEMENT.SaveError': "Salvarea nu a putut fi confirmată. Verifică conexiunea și încearcă din nou.",
    'STAFF_MANAGEMENT.NoManageAccess': "Nu ai permisiunea să setezi sau să modifici acest punct de pontaj.",
    'STAFF_MANAGEMENT.NoAttendanceAccess': "Nu ai permisiunea să vezi prezența personalului.",
    'STAFF_MANAGEMENT.SelectExhibition': "Selectează mai întâi un eveniment.",
    'STAFF_MANAGEMENT.Loading': "Se încarcă…",
    'STAFF_MANAGEMENT.Retry': "Încearcă din nou",
    'STAFF_MANAGEMENT.Back': "Înapoi",
    'STAFF_MANAGEMENT.QrTitle': "Cod QR pentru pontaj",
    'STAFF_MANAGEMENT.QrMissing': "Codul QR pentru pontaj nu este încă disponibil.",
    'STAFF_MANAGEMENT.QrError': "Codul QR nu a putut fi încărcat. Încearcă din nou.",
    'STAFF_MANAGEMENT.DownloadPdf': "Descarcă PDF",
    'STAFF_MANAGEMENT.PdfLoading': "Se pregătește PDF-ul…",
    'STAFF_MANAGEMENT.PdfError': "PDF-ul nu a putut fi creat. Încearcă din nou.",
    'STAFF_MANAGEMENT.Today': "Astăzi",
    'STAFF_MANAGEMENT.ChooseDate': "Alege data",
    'STAFF_MANAGEMENT.ChooseCompany': "Alege compania",
    'STAFF_MANAGEMENT.AllCompanies': "Toate companiile",
    'STAFF_MANAGEMENT.Apply': "Aplică",
    'STAFF_MANAGEMENT.NoCheckIn': "Intrare neînregistrată",
    'STAFF_MANAGEMENT.In': "Intrare",
    'STAFF_MANAGEMENT.Out': "Ieșire",
    'STAFF_MANAGEMENT.Working': "La lucru",
    'STAFF_MANAGEMENT.Completed': "Finalizat",
    'STAFF_MANAGEMENT.FailedCheckout': "Înregistrarea ieșirii a eșuat",
    'STAFF_MANAGEMENT.MissedCheckout': "Ieșire neînregistrată",
    'STAFF_MANAGEMENT.UnknownStatus': "Stare necunoscută",
    'STAFF_MANAGEMENT.NoAttendanceRecords': "Nu există înregistrări de prezență pentru această dată.",
    'STAFF_MANAGEMENT.NoMatches': "Niciun lucrător nu corespunde filtrelor selectate.",
    'STAFF_MANAGEMENT.AttendanceError': "Prezența nu a putut fi încărcată. Încearcă din nou.",
    'STAFF_MANAGEMENT.UnknownCompany': "Companie nespecificată",
    'STAFF_MANAGEMENT.LoadPointError': "Punctul de pontaj nu a putut fi încărcat. Încearcă din nou.",
    'STAFF_MANAGEMENT.PosterTitle': "Pontaj intrare / ieșire",
    'STAFF_MANAGEMENT.PosterInstructions': "Deschide aplicația ELFE și scanează acest cod QR la începutul și la sfârșitul lucrului.",
    'STAFF_MANAGEMENT.PosterGenerated': "Cod QR generat: { date }",
    'PHOTO_SOURCE.TakePhoto' : 'Fă o fotografie',
    'PHOTO_SOURCE.ChooseFromGallery' : 'Alege din galerie',
    'CRAFT.Type_Logistics' : 'Logistică { number }',
    'CRAFT.Type_Floor' : 'Pardoseală { number }',
    'CRAFT.Type_Assembly' : 'Montaj { number }',
    'CRAFT.Type_Electrics' : 'Electrice { number }',
    'CRAFT.Type_Graphic' : 'Grafică { number }',
    'CRAFT.Type_Furniture' : 'Mobilier { number }',
    'CRAFT.Type_Multimedia' : 'Multimedia { number }',
    'CRAFT.Type_Cleaning' : 'Curățenie { number }',
    'CRAFT.Type_Additional' : 'Suplimentar { number }',
    'CRAFT.Type_MPControl' : 'Control MP',
    'CRAFT.Type_Protocol' : 'Protocol',
    'CRAFT.Type_Service' : 'Service { number }',
    'CRAFT.Type_CollectGraphics' : 'Colectare grafică',
    'CRAFT.Status_Text_InProgress' : 'În curs',
    'CRAFT.Status_Text_Disabled' : 'Dezactivat',
    'CRAFT.Status_Text_Completed' : 'Finalizat',
    'CRAFT.Status_Text_Overdue' : 'Întârziat',
    'CRAFT.Status_Text_Done' : 'Colectat',
    'CRAFT.Status_Text_Open' : 'Deschis',
    'CRAFT.Status_Text_Collected': 'Colectat',
    'CRAFT.Status_Warning_Cannot_Change_Done': 'Nu se poate schimba statusul: grafica a fost deja procesată în panoul admin',
    'CRAFT.Button_ViewAll' : 'Vezi tot',
    'CRAFT.Button_Text_Print' : 'Tipărește',
    'CRAFT.Button_Text_Stand' : 'Stand',
    'CRAFT.Button_Text_MarkOpen' : 'Marchează lucrarea deschisă',
    'CRAFT.Button_Text_MarkDone' : 'Marchează lucrarea finalizată',
    'CRAFT.Button_Text_MarkInProgress' : 'Marchează lucrarea în curs',
    'CRAFT.Button_ChangeStatus_InProgress' : 'În curs',
    'CRAFT.Button_ChangeStatus_Done': 'Gata',
    'CRAFT.Button_Text_ShelfNumber' : 'Nr. raft',
    'CRAFT.Filter_Params_CraftType' : 'Lucrare: { withFilter }',
    'EXHIBITION.Select_Instruction' : 'Selectați o expoziție { br } din lista de mai jos',
    'EXHIBITION.Select_Label' : 'EXPOZIȚIE SELECTATĂ',
    'EXHIBITION.Modal_Title' : 'ALEGE EXPOZIȚIA',
    'EXHIBITION.Timer_State_Underway' : 'ÎN CURS',
    'EXHIBITION.Timer_State_Ended' : 'ÎNCHEIAT',
    'EXHIBITION.Title_CraftTotal' : 'Prezentare totală lucrări',
    'EXHIBITION.Statistic_Status_InTotal' : 'în total',
    'EXHIBITION.Statistic_Status_InProgress' : 'în curs',
    'EXHIBITION.Statistic_Status_Done' : 'gata',
    'EXHIBITION.Statistic_Status_Overdue' : 'întârziat',
    'EXHIBITION.Statistic_Status_NotApproved' : 'neaprobat',
    'EXHIBITION.Statistic_Status_BookedForExhibition' : 'alocați expoziției',
    'EXHIBITION.Statistic_Status_CheckedIn' : 'Înregistrați la intrare',
    'EXHIBITION.Statistic_Type_Stands' : 'Standuri',
    'EXHIBITION.Statistic_Type_Claims' : 'Reclamații MP',
    'EXHIBITION.Statistic_Type_CustomerClaims' : 'Reclamații expozant',
    'EXHIBITION.Statistic_Type_LastMinute' : 'Last minute',
    'EXHIBITION.Statistic_Type_MpControl' : 'Control MP',
    'EXHIBITION.Statistic_Type_Damages' : 'Daune',
    'EXHIBITION.Statistic_Type_Protocol' : 'Protocol',
    'EXHIBITION.Statistic_Type_Staff' : 'Personal',
    'FORM.Textarea_Placeholder_JobDescription' : 'Descriere sarcină*',
    'FORM.Button_Text_AddJob' : 'Adaugă sarcină',
    'FORM.Button_Text_SaveJob' : 'Salvează sarcina',
    'FORM.Button_AddJobPhoto' : 'Adaugă fotografie',
    'FORM_RULES.Required_Login' : 'Introduceți loginul',
    'FORM_RULES.Required_Password' : 'Introduceți parola',
    'FORM_RULES.Required_KeyDescription' : 'Introduceți descrierea cheii',
    'FORM_RULES.Required_KeyNumber' : 'Introduceți numărul cheii',
    'FORM_RULES.Required_JobDescription' : 'Adăugați descrierea sarcinii',
    'FORM_RULES.Required_Quantity' : 'Introduceți cantitatea',
    'FORM_RULES.Min_Quantity' : 'Cantitatea trebuie să fie un număr de cel puțin unu',
    'FORMS.Input_Label_Login' : 'login',
    'FORMS.Input_Label_Password' : 'parolă',
    'FORMS.Button_Text_Login' : 'Autentificare',
    'FORMS.Input_Label_Description' : 'Descriere',
    'FORMS.Input_Label_KeyNumber' : 'Număr cheie',
    'FORMS.Input_Label_Hall' : 'Hală',
    'FORMS.Input_Label_Stands' : 'Standuri',
    'FORMS.Button_Text_ApplyFilters' : 'Aplică',
    'FORMS.Button_Text_ResetFilters' : 'Resetează filtrele',
    'FORMS.Select_DefaultValue_All' : 'Toate',
    'FORMS.Select_StandTypeValue_CraftInProgress' : 'Cu lucrări în curs',
    'FORMS.Select_StandTypeValue_CraftCompleted' : 'Cu lucrări finalizate',
    'FORMS.Select_StandTypeValue_ControlInProgress' : 'Cu controale în curs',
    'FORMS.Select_StandTypeValue_ProtocolInProgress' : 'Cu protocoale în curs',
    'FORMS.Select_StandTypeValue_OverdueCrafts' : 'Cu lucrări întârziate',
    'FORMS.Select_StandTypeValue_AdditionalJobs' : 'Cu sarcini suplimentare',
    'FORMS.Button_Text_ApplySort' : 'Aplică',
    'FORMS.Input_Label_CraftType' : 'Tip lucrare',
    'FORMS.Input_Label_JobType'   : 'Tip',
    'FORMS.Input_Label_JobFlag'   : 'Marcaj',
    'FORMS.Input_Label_JobStatus' : 'Status',
    'FORMS.Input_Label_CraftStatus' : 'Status lucrare',
    'FORMS.Input_Label_DamageStatus' : 'Status daune',
    'FORMS.Input_Label_Subcontractor' : 'Subcontractor',
    'FORMS.Input_Label_Comments' : 'Comentarii',
    'FORMS.Select_JobStatusValue_JobsOpen' : 'Sarcini deschise',
    'FORMS.Select_JobStatusValue_JobsInProgress' : 'Sarcini în curs',
    'FORMS.Select_JobStatusValue_FinishedJobs' : 'Sarcini finalizate',
    'FORMS.Select_JobFlag_WithoutFlag' : 'Fără marcaj',
    'FORMS.Select_JobFlag_WithFlag' : 'Cu marcaj',
    'FORMS.Input_Label_FurnishingName' : 'Nume mobilier',
    'FORMS.Input_Label_FurnishingReturnQuantity' : 'Cantitate',
    'FORMS.Input_Label_Quantity' : 'Cantitate',
    'FORMS.Input_Label_CurrentQuantity' : 'Cantitate curentă',
    'FORMS.Input_Label_NewQuantity' : 'Cantitate nouă',
    'FORMS.RadioInput_Text_Description' : 'Descriere',
    'FORMS.RadioInput_Text_Furnishing' : 'Mobilier',
    'FORMS.RadioInput_Text_FurnishingClaim' : 'Mobilier',
    'FORMS.Input_Label_OrderType'   : 'Tip',
    'FORMS.Select_FurnishingOrder_Type_Return' : "Retur articol",
    'FORMS.Select_FurnishingOrder_Type_Lost' : "Pierdut",
    'FORMS.Select_FurnishingOrder_Type_Correction' : "Modifică totalul",
    'FORMS.Select_FurnishingOrder_Type_Order' : "Comandă",
    'GLOBAL.Button_Text_Logout' : 'Deconectare',
    'GLOBAL.Button_Text_Filter' : 'Filtru',
    'GLOBAL.Button_Text_Sort' : 'Sortare',
    'GLOBAL.Text_Version' : 'Versiune { versionNumber }',
    'GLOBAL.Button_Text_Cancel' : 'Anulează',
    'ATTENDANCE.Button_CheckIn': 'Intrare',
    'ATTENDANCE.Button_CheckOut': 'Ieșire',
    'ATTENDANCE.SelectExhibitionFirst_Text': 'Selectați mai întâi o expoziție.',
    'ATTENDANCE.Button_RetryScan': 'Scanează din nou',
    'ATTENDANCE.Button_Close': 'Închide',
    'ATTENDANCE.Modal_Title_CheckIn': 'Scanează intrarea',
    'ATTENDANCE.Modal_Title_CheckOut': 'Scanează ieșirea',
    'ATTENDANCE.Scanner_Hint': 'Îndreptați camera spre codul QR',
    'ATTENDANCE.Processing_Locating_Title': 'Vă determinăm locația mai precis…',
    'ATTENDANCE.Processing_Locating_Text': 'Vă rugăm să rămâneți pe loc. Acest lucru poate dura până la 15 secunde.',
    'ATTENDANCE.Processing_Submitting_Title': 'Se trimite scanarea...',
    'ATTENDANCE.Processing_Submitting_Text': 'Vă rugăm așteptați. Se salvează timpul de lucru.',
    'ATTENDANCE.Error_GpsPermission_Title': 'Accesul la locație este necesar',
    'ATTENDANCE.Error_GpsPermission_Text': 'Permiteți accesul la locație în browser și încercați din nou.',
    'ATTENDANCE.Error_GpsTimeout_Title': 'Semnal GPS slab',
    'ATTENDANCE.Error_GpsTimeout_Text': 'Coordonatele nu au fost găsite. Apropiați-vă de ieșire și scanați din nou.',
    'ATTENDANCE.Error_GpsUnavailable_Title': 'GPS indisponibil',
    'ATTENDANCE.Error_GpsUnavailable_Text': 'Datele de localizare nu sunt disponibile pe acest dispozitiv.',
    'ATTENDANCE.Error_Camera_Title': 'Camera nu este disponibilă',
    'ATTENDANCE.Error_Camera_Text': 'Permiteți accesul la cameră și încercați din nou.',
    'ATTENDANCE.Error_CameraPermission_Title': 'Accesul la cameră este blocat',
    'ATTENDANCE.Error_CameraPermission_Text': 'Permiteți accesul la cameră în setările site-ului din browser și încercați din nou.',
    'ATTENDANCE.Error_CameraNotFound_Title': 'Nu s-a găsit nicio cameră',
    'ATTENDANCE.Error_CameraNotFound_Text': 'Acest dispozitiv nu oferă browserului o cameră disponibilă.',
    'ATTENDANCE.Error_SecureContext_Title': 'HTTPS necesar',
    'ATTENDANCE.Error_SecureContext_Text': 'Camera și GPS-ul în browserul mobil funcționează doar prin HTTPS. Deschideți aplicația printr-un tunel HTTPS de dezvoltare.',
    'ATTENDANCE.Error_Server_Title': 'Scanarea a eșuat',
    'ATTENDANCE.Error_Server_Text': 'Serverul nu a procesat scanarea. Verificați conexiunea la internet și încercați din nou.',
    'ATTENDANCE.Error_Generic_Title': 'Scanarea a eșuat',
    'ATTENDANCE.Error_Generic_Text': 'Încercați din nou.',
    'ATTENDANCE.Result_CheckInAccepted_Title': 'Intrare reușită',
    'ATTENDANCE.Result_CheckOutAccepted_Title': 'Ieșire reușită',
    'ATTENDANCE.Result_Accepted_Text': 'Ora: { serverTime }. Sunteți înregistrat în sistem.',
    'ATTENDANCE.Result_Duplicate_Title': 'Deja înregistrat',
    'ATTENDANCE.Result_Duplicate_Text': 'Această scanare a fost deja salvată.',
    'ATTENDANCE.Result_OpenSessionElsewhere_Title': 'Intrare înregistrată la o altă expoziție',
    'ATTENDANCE.Result_OpenSessionElsewhere_Text': 'Înregistrați ieșirea de acolo înainte de a înregistra intrarea aici. Dacă nu aveți acces la acea expoziție, contactați responsabilul de șantier sau de proiect.',
    'ATTENDANCE.Result_ShiftClosed_Title': 'Tura este deja închisă',
    'ATTENDANCE.Link_MyTimeRecords': 'Vezi timpul meu de lucru',
    'ATTENDANCE.Result_ShiftClosed_Text': 'Tura dumneavoastră este deja închisă. Dacă nu v-ați înregistrat ieșirea, este posibil să fi fost închisă de un manager. Pentru a începe o tură nouă, înregistrați intrarea.',
    'ATTENDANCE.Result_AlreadyCheckedIn_Title': 'Intrare deja înregistrată',
    'ATTENDANCE.Result_AlreadyCheckedIn_Text': 'Înregistrați ieșirea de la această expoziție înainte de a înregistra din nou intrarea.',
    'ATTENDANCE.Result_Rejected_Title': 'Acces respins',
    'ATTENDANCE.Result_OutsideRadius_Text': 'Sunteți prea departe de intrare. Apropiați-vă de intrare.',
    'ATTENDANCE.Result_InvalidQr_Text': 'Acest cod QR nu este valid pentru intrare/ieșire.',
    'ATTENDANCE.Result_GenericRejected_Text': 'Scanarea a fost respinsă.',
    'ATTENDANCE.Button_Back': 'Înapoi',
    'ATTENDANCE.Button_TryAgain': 'Încearcă din nou',
    'ATTENDANCE.Button_GotIt': 'Am înțeles',
    'ATTENDANCE.Overview_NotCheckedIn': 'Intrarea nu este înregistrată',
    'ATTENDANCE.Overview_CheckInPrompt': 'Înregistrează intrarea scanând codul QR',
    'ATTENDANCE.Overview_CheckedIn_Label': 'Intrare înregistrată',
    'ATTENDANCE.Overview_CheckedInAt': 'la { time }',
    'ATTENDANCE.Scanner_CheckIn_Hint': 'Înainte de a începe lucrul, scanați codul QR pentru a înregistra intrarea',
    'ATTENDANCE.Scanner_CheckOut_Hint': 'Pentru ieșire, îndreptați camera spre codul QR de la expoziție',
    'ATTENDANCE.Error_StatusLoad_Text': 'Starea intrării nu a putut fi încărcată.',
    'ATTENDANCE.Error_CameraDesign_Title': 'Aplicația nu poate deschide camera',
    'ATTENDANCE.Error_CameraDesign_Text': 'Pentru intrare trebuie să scanați codul cu camera telefonului. Apăsați Încearcă din nou și permiteți accesul la cameră.',
    'ATTENDANCE.Error_Camera_Settings_Hint': 'Tot nu funcționează? Verificați permisiunea camerei în setările browserului.',
    'ATTENDANCE.Error_LocationDesign_Title': 'Aplicația nu vă poate vedea locația',
    'ATTENDANCE.Error_LocationDesign_Text': 'Locația este necesară pentru confirmarea prezenței. Activați-o în setările telefonului și încercați din nou.',
    'ATTENDANCE.Result_CheckedInAt': 'Intrarea a fost înregistrată pe { date } la { time }',
    'ATTENDANCE.Result_CheckInSuccessAt': 'Ați înregistrat cu succes intrarea la serviciu la ora { time }.',
    'ATTENDANCE.Result_CheckedOutAt': 'Ați terminat lucrul și ați înregistrat{ br }ieșirea la { time }',
    'ATTENDANCE.Result_OutsideRadius_Title': 'Trebuie să fiți la locația evenimentului',
    'ATTENDANCE.Result_OutsideRadius_DesignText': 'Locația dvs. nu corespunde expoziției. Intrările sunt înregistrate prin GPS. Încercați din nou la locația corectă.',
    'ATTENDANCE.Result_LowAccuracy_Title': 'Precizie redusă a locației',
    'ATTENDANCE.Result_LowAccuracy_Badge': 'Precizie: { accuracy } (Prea redusă)',
    'ATTENDANCE.Result_LowAccuracy_CheckIn': 'Pentru a înregistra intrarea:',
    'ATTENDANCE.Result_LowAccuracy_CheckOut': 'Pentru a înregistra ieșirea:',
    'ATTENDANCE.Result_LowAccuracy_PreciseLocation': 'Activați „Locație precisă” pentru browser în setările telefonului',
    'ATTENDANCE.Result_LowAccuracy_Wifi': 'Activați Wi-Fi pentru a ajuta la localizarea dispozitivului',
    'ATTENDANCE.Result_LowAccuracy_Retry': 'Apoi apăsați pe { back } și scanați din nou codul.',
    'ATTENDANCE.Accuracy_Meters': '{ value } m',
    'ATTENDANCE.Accuracy_Kilometers': '{ value } km',
    'ATTENDANCE.Result_InvalidQr_Title': 'Acesta nu este codul corect',
    'ATTENDANCE.Result_InvalidQr_CheckIn_Title': 'Înregistrarea intrării nu este posibilă!',
    'ATTENDANCE.Result_InvalidQr_CheckOut_Title': 'Înregistrarea ieșirii nu este posibilă!',
    'ATTENDANCE.Result_InvalidQr_DesignText': 'Acest cod QR nu corespunde evenimentului dumneavoastră. Vă rugăm să vă adresați responsabilului de șantier sau de proiect.',
    'ATTENDANCE.Result_OutdatedQr_Text': 'Acest cod QR nu mai este valabil. Vă rugăm să scanați cel mai recent cod QR.',
    'ATTENDANCE.Result_DeviceConflict_Title': 'Înregistrarea intrării nu este posibilă!',
    'ATTENDANCE.Result_DeviceConflict_Text': 'O altă persoană și-a înregistrat deja intrarea folosind acest telefon. Aplicația nu permite ca doi utilizatori diferiți să își înregistreze intrarea folosind același dispozitiv!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Title': 'Scanarea la intrare nu este posibilă!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Text': 'Înregistrarea intrării este posibilă numai în perioada stabilită pentru eveniment. Vă rugăm să vă adresați responsabilului de șantier sau de proiect.',
    'ATTENDANCE.Result_OutsideSchedule_CheckOut_Title': 'Înregistrarea ieșirii nu este disponibilă acum',
    'ATTENDANCE.Result_OutsideSchedule_Text': 'Această acțiune este disponibilă numai în perioada configurată a expoziției. Verificați expoziția selectată și datele acesteia.',
    'ATTENDANCE.TimeRecords_InProgress': 'în curs',
    'ATTENDANCE.TimeRecords_Missed': 'omis',
    'ATTENDANCE.TimeRecords_Empty': 'Nu există înregistrări de timp.',
    'ATTENDANCE.Error_TimeRecordsLoad_Text': 'Înregistrările de timp nu au putut fi încărcate.',
    'MENUS.Label_MyTimeRecords': 'Timpul meu de lucru',
    'PAGE.Title_MyTimeRecords': 'Timpul meu de lucru',
    'GLOBAL.Badge_Text_New' : 'NOU',
    'GLOBAL.Modal_Title_Filters' : 'Filtre',
    'GLOBAL.Modal_Title_SortBy' : 'Sortare după',
    'GLOBAL.TimeLeft' : 'mai rămâne { timeLeft }',
    'GLOBAL.Text_Piece' : 'buc.',
    'GLOBAL.Button_Text_Confirm' : 'Confirmă',
    'GLOBAL.Language_Default' : 'Implicit',
    'TRANSLATION.Button_Text_Translate' : 'Tradu',
    'TRANSLATION.Button_Text_TranslateInput' : 'Tradu în germană',
    'TRANSLATION.Button_Text_TranslateEnglish' : 'Tradu în engleză',
    'TRANSLATION.Button_Text_TranslateNative' : 'Tradu în limba mea',
    'TRANSLATION.Button_Text_ShowOriginal' : 'Afișează germana originală',
    'TRANSLATION.Text_InputTranslating' : 'Se traduce...',
    'TRANSLATION.Text_InputTranslated' : 'Tradus',
    'TRANSLATION.Text_InputTranslationError' : 'Traducerea a eșuat',
    'TRANSLATION.Text_InputTranslationRequired' : 'Vă rugăm să traduceți textul înainte de trimitere',
    'TRANSLATION.Text_ApiUnavailable' : 'Traducerea nu este disponibilă momentan',
    'GLOBAL.Card_Hero_Hall' : 'Hală',
    'GLOBAL.Card_Hero_Block' : 'Bloc',
    'GLOBAL.Card_Hero_Stand' : 'Stand',
    'GLOBAL.Comment': 'Comentariu',
    'HALL.Button_Text_HallPlan' : 'Plan hală',
    'HALL.Link_Text_HallPlan' : 'Plan hală { hallName }',
    'JOB.Tag_Claim' : 'C',
    'JOB.Tag_CustomerClaim' : 'C',
    'JOB.Tag_MPAndCustomerClaim' : 'C',
    'JOB.Tag_LastMinute' : 'LM',
    'JOB.Tag_Damage' : 'D',
    'JOB.Tag_ProtocolDefect' : 'PD',
    'JOB.Card_Hero_Hall' : 'Hală',
    'JOB.Card_Hero_Number' : 'Nr. sarcină',
    'JOB.Card_Hero_Block' : 'Bloc',
    'JOB.Card_Hero_Stand' : 'Stand',
    'JOB.Card_Hero_Exhibitor' : 'Expozant',
    'JOB.Button_Text_ToTheStand' : 'La stand',
    'JOB.Text_Creator' : 'de { whoCreate } la { whenCreate }',
    'JOB.Text_InWork' : 'de { whoWork } la { whenWork }',
    'JOB.Text_Executor' : 'de { whoExecute } la { whenExecute }',
    'JOB.Text_DurationTime' : 'Durată: { time }',
    'JOB.Type_Claim' : 'Reclamație MP',
    'JOB.Type_AllClaims' : 'Reclamație',
    'JOB.Type_CustomerClaim' : 'Reclamație expozant',
    'JOB.Type_LastMinute' : 'Last minute',
    'JOB.Type_Damage' : 'Daună',
    'JOB.Type_ProtocolDefect' : 'Defect protocol',
    'JOB.Button_ChangeStatus_Waiting' : 'Preia sarcina',
    'JOB.Button_ChangeStatus_InProgress' : 'Sarcină în curs',
    'JOB.Button_ChangeStatus_Done' : 'Finalizează sarcina',
    'JOB.Modal_Title_Photo' : 'Fotografie sarcină',
    'JOB.Filter_Params_JobType' : 'Tip: { withFilter }',
    'JOB.Filter_Params_CraftType' : 'Lucrare: { withFilter }',
    'JOB.Modal_Title_NewJob' : 'Nou { jobType }',
    'JOB.Modal_Title_EditJob' : 'Editează { jobType }',
    'JOB.Button_Text_AddClaim' : 'Adaugă reclamație MP',
    'JOB.Button_Text_AddCustomerClaim' : 'Adaugă reclamație expozant',
    'JOB.Button_Text_AddLastMinute' : 'Adaugă sarcină last minute',
    'JOB.Button_Text_AddDamage' : 'Adaugă fotografie daună',
    'JOB.Button_Text_AddProtocolDefect' : 'Adaugă defect protocol',
    'DAMAGE.Card_Title' : 'Daune ale { exhibitor }',
    'DAMAGE.Modal_Title_Photo' : 'Daune { exhibitor }',
    'DAMAGE.Status_Label_New' : 'Neverificat',
    'DAMAGE.Status_Label_Check' : 'Verificat',
    'DAMAGE.Status_Label_DCheck' : 'Aprobat',
    'DAMAGE.Button_Text_Stand' : 'Stand',
    'DAMAGE.Button_Text_Photo' : 'Foto',
    'DAMAGE.Button_Text_AddNote' : "ADAUGĂ NOTĂ",
    'DAMAGE.Modal_Button_AddPhoto' : 'Adaugă fotografie',
    'DAMAGE.Modal_Button_CreateReport' : 'Creează raport',
    'DAMAGE.Modal_Button_EditReport' : 'Editează raport',
    'DAMAGE.AsCraft_label' : "Daune",
    "DAMAGE.Button_Text_Open" : "Deschide",
    "STAND.Block_Title_Damages" : "Daune",
    'MENUS.Label_Overview' : 'Prezentare',
    'MENUS.Label_Stands' : 'Standuri',
    'MENUS.Label_Jobs' : 'Sarcini',
    'MENUS.Label_ExpoPlan' : 'Plan expo',
    'MENUS.Label_More' : 'Mai mult',
    'MENUS.Label_SelectExhibition' : 'Selectează expoziția',
    'MENUS.Label_CraftsOverview' : 'Prezentare lucrări',
    'MENUS.Label_HallsOverview' : 'Prezentare hale',
    'MENUS.Label_ViewDamages' : 'Vezi daune',
    'MENUS.Label_Downloads' : 'Descărcări',
    'MENUS.Label_Documents' : 'Documente',
    'MENUS.Label_FurnishingLeftovers' : 'Resturi mobilier',
    'MENUS.Label_HelpImprint' : 'Imprint',
    'MENUS.Label_CollectGraphics' : 'Colectare grafică',
    'NO_DATA.Exhibitions' : 'Nu aveți încă nicio expoziție.',
    'NO_DATA.Documents' : 'Expoziția curentă nu are { br } încă documente.',
    'NO_DATA.Stands' : 'Nu au fost găsite standuri { br } pentru căutare',
    'NO_DATA.StandPhoto' : 'Nu aveți încă fotografie de stand',
    'NO_DATA.DamagePhoto' : 'Nu aveți încă fotografie cu daunele { br } acestui stand',
    'NO_DATA.Stand_NoKeys' : 'Acest stand nu are încă chei',
    'NO_DATA.Stand_DoesNotExist' : 'Acest stand nu există',
    'NO_DATA.Subcontractor_Unsigned' : 'Nesemnat',
    'NO_DATA.Jobs' : 'Nu au fost găsite sarcini { br } pentru căutare',
    'NO_DATA.Damages' : 'Nu au fost găsite daune { br } pentru căutare',
    'NO_DATA.Hall' : 'Această hală nu există',
    'NO_DATA.HallPlan' : 'Nu am găsit un plan al acestei hale',
    'NO_DATA.Furnishing_Storage' : 'Această expoziție nu are { br } mobilier în stoc',
    'NO_DATA.Furnishing_Orders' : 'Această expoziție nu are { br } comenzi de mobilier',
    'PAGE.Title_Overview' : 'Prezentare',
    'PAGE.Title_ExhibitionSelection' : 'Selectare expoziție',
    'PAGE.Title_Stands' : 'Standuri',
    'PAGE.Title_Stand' : 'Stand',
    'PAGE.Title_StandComments' : 'Comentarii stand',
    'PAGE.Title_StandLog' : 'Jurnal stand',
    'PAGE.Title_StandKeys' : 'Chei stand',
    'PAGE.Title_ViewDamages' : 'Vezi daune',
    'PAGE.Title_AdditionalMenu' : 'Meniu suplimentar',
    'PAGE.Title_Jobs' : 'Sarcini',
    'PAGE.Title_ExpoPlan' : 'Plan expo',
    'PAGE.Title_Documents' : 'Documente',
    'PAGE.Title_FurnishingLeftovers' : 'Mobilier LM',
    'PAGE.Title_FurnishingReturns' : 'Jurnal modificări mobilier',
    'PAGE.Title_HallPlan' : 'Plan hală',
    'PAGE.Title_HallsOverview' : 'Prezentare hale',
    'PAGE.Title_CraftsOverview' : 'Prezentare lucrări',
    'PAGE.Title_HelpImprint' : 'Imprint',
    'PAGE.Title_CollectGraphics' : 'Colectare grafică',
    'SORT.Text_NewestByCreation' : 'Cele mai noi după data creării',
    'SORT.Text_OldestByCreation' : 'Cele mai vechi după data creării',
    'SORT.Text_ExhibitorNameAZ' : 'Nume expozant (A-Z)',
    'SORT.Text_ExhibitorNameZA' : 'Nume expozant (Z-A)',
    'SORT.Text_FinishedFirst' : 'Finalizate primele',
    'SORT.Text_InProgressFirst' : 'Deschise primele',
    'SORT.Text_StandNumberAZ' : 'Număr stand (A-Z)',
    'SORT.Text_StandNumberZA' : 'Număr stand (Z-A)',
    'SORT.Text_CorridorAZ' : 'Coridor (A-Z)',
    'SORT.Text_CorridorZA' : 'Coridor (Z-A)',
    'SORT.Text_BlockAZ' : 'Bloc (A-Z)',
    'SORT.Text_BlockZA' : 'Bloc (Z-A)',
    'SORT.Text_FlagFirst' : 'Cu marcaj primele',
    'SORT.Text_FlagLast' : 'Cu marcaj ultimele',
    'SORT.Text_HallAZ' : 'Hală (A-Z)',
    'SORT.Text_HallZA' : 'Hală (Z-A)',
    'SORT.Text_StatusAZ' : 'Aprobat',
    'SORT.Text_StatusZA' : 'Neverificat',
    'STAND.Modal_Title_Search' : 'Căutare',
    'STAND.Input_Placeholder_Search' : 'Căutare',
    'STAND.Filter_Params_Exhibitor' : 'Expozant: { exhibitorName }',
    'STAND.Filter_Params_WithComments' : 'Cu comentarii',
    'STAND.Card_Hero_Hall' : 'Hală',
    'STAND.Card_Hero_Block' : 'Bloc',
    'STAND.Card_Hero_Stand' : 'Stand',
    'STAND.Card_Hero_DeliveryTime' : 'Ora livrării',
    'STAND.Modal_Title_StandPlan' : 'Desen stand',
    'STAND.Modal_Button_StandPlan' : 'Desen',
    'STAND.Card_Button_Details' : 'Detalii { icon }',
    'STAND.Modal_Title_StandPhoto' : 'Fotografie stand',
    'STAND.Modal_Button_StandPhoto' : 'Foto',
    'STAND.Modal_Button_SavePhoto' : 'Salvează fotografia',
    'STAND.Modal_Button_AddPhoto' : 'Adaugă fotografie',
    'STAND.Button_Text_Comments' : 'Comentarii',
    'STAND.Button_Text_AddComment' : 'Adaugă comentariu',
    'STAND.Modal_Title_AddComment' : 'Adaugă comentariu',
    'STAND.Modal_Title_EditComment' : 'Editează comentariu',
    'STAND.Modal_Button_AddComment' : 'Adaugă',
    'STAND.Modal_Button_SaveComment' : 'Salvează',
    'STAND.Text_NoComments' : 'Nu există încă comentarii',
    'STAND.Text_AddFile' : 'Adaugă fișier',
    'COMMENTS.Text_Uploading' : 'Se încarcă...',
    'STAND.Text_EditComment' : 'Editează',
    'STAND.Text_DeleteComment' : 'Șterge',
    'STAND.Text_CommentDraftError' : 'Schița comentariului nu este încă pregătită',
    'STAND.Block_Title_Overview' : 'Prezentare',
    'STAND.Block_Title_Materials' : 'Informații suplimentare',
    'STAND.Block_Title_Crafts' : 'Lucrări',
    'STAND.Block_ItemTitle_Hall' : 'Hală',
    'STAND.Block_ItemTitle_Block' : 'Bloc',
    'STAND.Block_ItemTitle_Stand' : 'Stand',
    'STAND.Block_ItemTitle_ProaufNumber' : 'Număr Proauf',
    'STAND.Block_ItemTitle_Jobs' : 'Sarcini',
    'STAND.Block_Item_JobCountInProgress' : '{ jobCount } în curs',
    'STAND.Block_Item_JobCountOpen' : '{ jobCount } deschise',
    'STAND.Block_Item_JobCountFinished' : '{ jobCount } finalizate',
    'STAND.Block_Button_ViewStandJobs' : 'Vezi sarcinile standului',
    'STAND.Modal_Title_StandGraphic' : 'Grafică stand',
    'STAND.Modal_Button_StandGraphic' : 'Grafică stand',
    'STAND.Modal_Title_ExtraInfo' : 'Informații extra',
    'STAND.Modal_Button_ExtraInfo' : 'Informații extra',
    'STAND.Button_Text_ViewKeys' : 'Vezi cheile',
    'STAND.Button_Text_ViewLogs' : 'Vezi jurnalele',
    'STAND.Modal_Button_AddKey' : 'Adaugă cheie',
    'STAND.Modal_Title_AddKey' : 'Adaugă cheie',
    'STAND.Modal_Title_EditKey' : 'Editează cheia',
    'STAND.Modal_Button_UpdateKey' : 'Actualizează cheia',
    'STAND.Filter_Params_Stand' : 'Stand { withFilter }',
    'STAND.Button_Text_DeleteKey' : 'Șterge',
    'STAND.Text_ModalDelete_Question' : 'Sigur doriți să ștergeți cheia { keyName }?',
    'STAND.External_Exhibition' : 'Expoziție la care nu sunteți asignat',
    'JOB.Button_Text_ViewPhoto' : 'Vezi fotografia',
    'OVERVIEW_TYPES.Label_InTotal' : 'în total',
    'OVERVIEW_TYPES.Label_Finished' : 'finalizate',
    'OVERVIEW_TYPES.Label_Open' : 'deschise',
    'OVERVIEW_TYPES.Label_Claims' : 'reclamații',
    'OVERVIEW_TYPES.Label_LastMinute' : 'last min',
    'OVERVIEW_TYPES.Label_Overdue' : 'întârziate',
    'FURNISHING.TabName_Storage' : 'Stoc',
    'FURNISHING.TabName_Refund' : 'Retururi',
    'FURNISHING.TabName_OrderLog' : 'Jurnal comenzi',
    'FURNISHING.Modal_Title_ReturnFurnishing' : 'Cantități echipament LM',
    'FURNISHING.Modal_Title_FurnishingStore' : 'Mobilier în stoc',
    'FURNISHING.Button_Text_Return' : 'Retur',
    'FURNISHING.Button_Text_ChooseFurnishing' : 'Alege mobilier',
    'FURNISHING.Modal_Title_Photo' : "Fotografie mobilier",
    'FURNISHING.Order_Type_Refund' : "Retur",
    'FURNISHING.Order_Type_Lost' : "Pierdut",
    'FURNISHING.Order_Type_Correction' : "Corecție",
    'FURNISHING.Order_Type_Order' : "Comandă",
};

export default romanian;
